import type { DropDownItem } from '@/components/common/DropDown.vue';
import { accountService } from '@/services/accounts/accounts-service';

export const fetchAccounts = async (): Promise<DropDownItem[]> => {
  let data: DropDownItem[] = [];
  try {
    const response = await accountService.getAll();
    if (response?.length > 0) {
      data = response.map((account) => ({
        value: account.number.toString(),
        text: `${account.number} - ${account.name}`,
      }));
    }
  } catch (error) {
    console.error(error);
  }
  return data;
};
